import React from 'react';
import { Skeleton } from '@mui/material';

interface Props {
  isLast?: boolean;
}

const BrowserItemSkeletonV2: React.FC<Props> = ({ isLast = false }) => (
  <Skeleton width="100%" height="46px" sx={{ transform: 'initial', marginBottom: isLast ? undefined : '10px' }} />
);

export default BrowserItemSkeletonV2;
